import { render, staticRenderFns } from "./MyProfile.vue?vue&type=template&id=61d8bd24&scoped=true&"
import script from "./MyProfile.vue?vue&type=script&lang=js&"
export * from "./MyProfile.vue?vue&type=script&lang=js&"
import style0 from "./my-profile.css?vue&type=style&index=0&id=61d8bd24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d8bd24",
  null
  
)

export default component.exports